import { useSelector } from "react-redux";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import NumberFormat from "react-number-format";

import { ItemsActions } from "../ItemsActions";
import { AutocompleteCategorias } from "../../../pptos/form/AutocompleteCategorias";

export const TitlesRow = ({ title, isEditMode }) => {
  const { categoriesGasto: categories } = useSelector((state) => state.general);
  const { separacion_miles, separacion_decimales, simbolo } = useSelector(
    (state) => state.pptoGasto.detail,
  );

  return (
    <TableRow
      className="p-table-rows"
      key={title.id}
      style={{ backgroundColor: "#f8f7f7" }}
    >
      {isEditMode && (
        <TableCell className="text-end p-border-separate">
          <ItemsActions
            item={title}
            openSubTitles={true}
            hanldeChangeOpenSubtitle={() => {
              return false;
            }}
            sorting={title?.items.length}
          />
        </TableCell>
      )}

      <TableCell align="left" className="sticky left-0 bg-[#f8f7f7]">
        <AutocompleteCategorias itemsOptions={categories} item={title} />
      </TableCell>
      <TableCell align="center"></TableCell>
      <TableCell align="center"></TableCell>

      {isEditMode && (
        <>
          <TableCell align="right"></TableCell>
          <TableCell align="right" className="p-border-separate ppto subtotal">
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={title.costo_subtotal}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              decimalScale={2}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>

          {/* ppto impuestos */}
          <TableCell
            align="right"
            className="ppto"
            style={{ backgroundColor: "white" }}
          >
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={title?.total_impuesto || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>
        </>
      )}

      <TableCell
        align="right"
        className="ppto"
        style={{ backgroundColor: "white" }}
      >
        <NumberFormat
          className="cantidades-title p-fs-12px"
          value={title?.total_a_pagar || 0}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
        />
        <Tooltip title="valor calculado, no modificable">
          <i className="bi bi-lock p-icon-block"></i>
        </Tooltip>
      </TableCell>

      {/* {isEditMode && (
        <>
          <TableCell align="right" className="p-border-separate actual">
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={title.total_gasto_real || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>
          <TableCell align="right" className="p-border-separate actual">
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={title?.total_gasto_impuesto || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>
        </>
      )}

      <TableCell align="right" className="p-border-separate actual">
        <NumberFormat
          className="cantidades-title p-fs-12px"
          value={title?.total_gasto_final || 0}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
        />
        <Tooltip title="valor calculado, no modificable">
          <i className="bi bi-lock p-icon-block"></i>
        </Tooltip>
      </TableCell> */}
      {/* <TableCell align="right" className="p-border-separate actual">
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={title.porcentaje_gasto_real}
                    displayType={'text'}
                    suffix=" %"
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell> */}

      {/* pagos */}
      {/*  <TableCell align="right" style={{ backgroundColor: 'white' }}>
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={title?.total_pagado || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell>
            <TableCell align="right" className="p-border-separate" style={{ backgroundColor: 'white' }}>
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={title?.total_por_pagar || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell>
 */}
      {/* por gastar */}
      {/* <TableCell align="right" className="p-border-separate dif">
        <NumberFormat
          className="cantidades-title p-fs-12px"
          value={title.total_por_gastar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
        />
        <Tooltip title="valor calculado, no modificable">
          <i className="bi bi-lock p-icon-block"></i>
        </Tooltip>
      </TableCell>
      <TableCell align="center"></TableCell> */}
    </TableRow>
  );
};
